import { useQuery } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { Booking, Meta } from 'utils/types';
import { useProvider } from 'utils/providers/Provider';

interface Result {
  data: Booking;
  meta: Meta;
}

export default function useGetPublicBookingEvent(
  id: string,
  params: Record<string, any>,
) {
  const { state } = useProvider();
  const args = state;
  return useQuery<Booking, Error>({
    queryFn: async () => {
      const api = new Api(args);

      const data: Result = await api.get({
        url: `api/public/calendar/moments/events/${id}`,
        params,
      });

      return data?.data;
    },
    enabled: !!id,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
